export default {
	methods: {
		/**
		 * Retrieve the user hasAccess field corresponding to its index type
		 * @param {number} index - Index of the user (corresponding to type field) between 1-3
		 * @return {string} Returns the Oui/Non for hasAccess field
		 */
        getImagePath: (imageName) => {
          try {
            switch (imageName.toLowerCase()) {
              case 'wordpress':
                return require("@/assets/icons/wordpress.webp");
              case 'gtm':
                return require("@/assets/icons/gtm.webp");
              case 'shopify':
                return require("@/assets/icons/shopify.webp");
              case 'google_analytics':
                return require("@/assets/icons/google_analytics.webp");
              case 'google_ads':
                return require("@/assets/icons/google_ads.webp");
              default:
                return require(`@/assets/icons/${imageName}.webp`); // or return an empty string ""
            }
          } catch (error) {
          return require(`@/assets/icons/internet.webp`)
        }
    }
}
}